import {Switch, Route, useRouteMatch} from 'react-router-dom';
import EditCustomer from './Edit';
import ShowCustomer from './Show';
import Customers from './Main';
import CreateLocation from '../locations/Create';
import CustomerRefunds from '../refunds/Customer';

export default () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}><Customers /></Route>
            <Route path={`${path}/:customerId/edit`}><EditCustomer /></Route>
            <Route exact path={`${path}/:customerId`}><ShowCustomer /></Route>
            <Route path={`${path}/:customerId/locations/create`}><CreateLocation /></Route>
            <Route path={`${path}/:customerId/refunds`}><CustomerRefunds /></Route>
        </Switch>
    )
}
